var map = {
	"./arrow-blue.svg": "6ccd",
	"./arrow-down.svg": "c874",
	"./arrow-green.svg": "4a62",
	"./arrow-white.svg": "0e6c",
	"./document.svg": "4aa0",
	"./email-contact.svg": "b05c",
	"./email.svg": "43be",
	"./kpam-logo.svg": "174a",
	"./legende-compare.svg": "e454",
	"./logout.svg": "69e3",
	"./occurence-baisse.svg": "5690",
	"./occurence-hausse.svg": "3ec0",
	"./occurence-stable.svg": "12ff",
	"./password.svg": "b009",
	"./pdf.svg": "5730",
	"./question.svg": "9872",
	"./satisfaction-moyenne.svg": "0abf",
	"./touchpoint-bonnepratique.svg": "a8b3",
	"./touchpoint-faible.svg": "3a2a",
	"./touchpoint-fort.svg": "4bdc",
	"./touchpoint-prioritaire.svg": "a60f",
	"./tracker.svg": "81ee",
	"./verbatim-negatif.svg": "1e76",
	"./verbatim-positif.svg": "50d9",
	"./verbatim.svg": "ed3b",
	"./video.svg": "512b",
	"./zoom-moins.svg": "ea90",
	"./zoom-plus.svg": "0678"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6f32";